import React from 'react';
import { Phone, MapPin, Clock } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-slate-300 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">
              Kingsway Auto Collision LTD
            </h3>
            <p className="text-slate-400 mb-4">
              Professional auto body repair services serving Burnaby and the Greater Vancouver area.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Contact Us</h4>
            <div className="space-y-3">
              <a
                href="tel:6045680063"
                className="flex items-center gap-2 hover:text-amber-500 transition-colors"
              >
                <Phone className="h-4 w-4" />
                <span>Main: 604-568-0063</span>
              </a>
              <a
                href="tel:6042032008"
                className="flex items-center gap-2 hover:text-amber-500 transition-colors"
              >
                <Phone className="h-4 w-4" />
                <span>Cell: 604-203-2008</span>
              </a>
              <a
                href="https://www.google.com/maps/search/?api=1&query=5368+Lane+Street+Burnaby+BC+Canada"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2 hover:text-amber-500 transition-colors"
              >
                <MapPin className="h-4 w-4 mt-1" />
                <span>5368 Lane Street<br />Burnaby, BC, Canada</span>
              </a>
            </div>
          </div>

          {/* Business Hours */}
          <div>
            <h4 className="text-lg font-bold text-white mb-4">Business Hours</h4>
            <div className="space-y-2">
              <div className="flex items-start gap-2">
                <Clock className="h-4 w-4 mt-1" />
                <div>
                  <p>Monday - Friday: 8:00 AM - 5:00 PM</p>
                  <p>Saturday: By Appointment</p>
                  <p>Sunday: Closed</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center">
          <p className="text-slate-500">
            © {currentYear} Kingsway Auto Collision LTD. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
